module.exports = __webpack_public_path__ + "static/img/1.527a364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/search/1.png
// module id = SiPE
// module chunks = 1